module.exports = __webpack_public_path__ + "img/901288630.21c89937.png";